import React, { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { Checkbox, FormControlLabel, FormGroup, Grid } from '@material-ui/core';
import SahamDrawer from 'components/SahamDrawer';
import { translate } from 'containers/services/translate';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import {
  Title,
  StyledCheckBox,
} from 'containers/LawyerLegalProceedingsPage/styled-components';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { difference, get, isEmpty, uniqueId } from 'lodash';
import { resolveVehicles } from 'containers/LawyerLegalProceedingsPage/utils';
import { getVehicleFromSagisInfo } from 'containers/PreOpeningPage/OpposingParty/utils';

export interface AddJomDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleSubmit: Function;
  handleToggleDrawer: Function;
  victims: any;
  vehicles: any;
  associatedVictims: any[];
  associatedVehicles: any[];
  setAssociatedVictims: Dispatch<SetStateAction<any[]>>;
  setAssociatedVehicles: Dispatch<SetStateAction<any[]>>;
  civilVictimsToInclude?: any;
  jomVictimsToInclude?: any;
  civilVehiclesToInclude?: number[] | undefined;
  jomVehiclesToInclude?: number[] | undefined;
  isCivilJudiciaryProcess?: boolean | undefined;
  jomDeceasedVictims?: any;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
}

const AddJomDrawer: React.FC<AddJomDrawerProps> = (props): JSX.Element => {
  const handleCheckVictim = (event: ChangeEvent<HTMLInputElement>) => {
    let newAssociatedVictims = [...props.associatedVictims];
    const newValue = parseInt(event.target.value);
    if (!props.associatedVictims.includes(newValue)) {
      newAssociatedVictims = [...props.associatedVictims, newValue];
    } else {
      newAssociatedVictims.splice(props.associatedVictims.indexOf(newValue), 1);
    }
    props.setAssociatedVictims(newAssociatedVictims);
  };

  const isCheckedVictim = (victimId: number) => {
    return props.associatedVictims.includes(victimId);
  };

  const isCheckedVehicle = (id: number) => {
    return props.associatedVehicles.includes(id);
  };

  const handleCheckVehicle = (event: ChangeEvent<HTMLInputElement>) => {
    let newAssociatedVehicles = [...props.associatedVehicles];
    const newValue = parseInt(event.target.value);
    if (!props.associatedVehicles.includes(newValue)) {
      newAssociatedVehicles = [...props.associatedVehicles, newValue];
    } else {
      newAssociatedVehicles.splice(
        props.associatedVehicles.indexOf(newValue),
        1,
      );
    }
    props.setAssociatedVehicles(newAssociatedVehicles);
  };
  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={() => props.handleToggleDrawer()}
      title={translate(messages.addJom, props)}
      handleValidateDrawer={() => props.handleSubmit()}
      confirmButtonTitle={translate(messages.validateButton, props)}
      isSaveButtonDisabled={
        isEmpty(props.associatedVictims) && isEmpty(props.associatedVehicles)
      }
    >
      {!isEmpty(props.victims) && (
        <Grid container spacing={1} direction={'column'}>
          <Grid item>
            <Title>{translate({ ...messages.victims }, props)}</Title>
          </Grid>

          <Grid item>
            <div className="check_box_container">
              {props.victims
                .filter((vic: any) =>
                  difference(
                    [...get(props, 'civilVictimsToInclude', [])],
                    [
                      ...get(props, 'jomVictimsToInclude', []),
                      ...get(props, 'jomDeceasedVictims', []),
                    ],
                  ).includes(vic.id),
                )
                .map(
                  (victim: { id: number; firstName: any; lastName: any }) => (
                    <FormGroup key={uniqueId()} style={StyledCheckBox}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isCheckedVictim(victim.id)}
                            name={
                              featureService.hasFeature(
                                FEATURES.MIGRATION_CLAIM_INFO,
                              )
                                ? `${get(
                                    getVictimFromSagisInfo(
                                      get(victim, 'victimKey'),
                                      props.sagisVictimInfo,
                                    ),
                                    'victimFirstName',
                                    '',
                                  )} ${get(
                                    getVictimFromSagisInfo(
                                      get(victim, 'victimKey'),
                                      props.sagisVictimInfo,
                                    ),
                                    'victimLastName',
                                    '',
                                  )}`
                                : `${victim.firstName} ${victim.lastName}`
                            }
                            color="primary"
                            value={victim.id}
                            onChange={handleCheckVictim}
                          />
                        }
                        label={
                          featureService.hasFeature(
                            FEATURES.MIGRATION_CLAIM_INFO,
                          )
                            ? `${get(
                                getVictimFromSagisInfo(
                                  get(victim, 'victimKey'),
                                  props.sagisVictimInfo,
                                ),
                                'victimFirstName',
                                '',
                              )} ${get(
                                getVictimFromSagisInfo(
                                  get(victim, 'victimKey'),
                                  props.sagisVictimInfo,
                                ),
                                'victimLastName',
                                '',
                              )}`
                            : `${victim.firstName} ${victim.lastName}`
                        }
                      />
                    </FormGroup>
                  ),
                )}
            </div>
          </Grid>
        </Grid>
      )}
      {!isEmpty(props.vehicles) && (
        <Grid container spacing={1} direction={'column'}>
          <Grid item>
            <Title>{translate({ ...messages.vehicles }, props)}</Title>
          </Grid>

          <Grid item>
            <div className="check_box_container">
              {props.vehicles
                .filter((v: any) =>
                  resolveVehicles(
                    get(props, 'civilVehiclesToInclude', []),
                    get(props, 'jomVehiclesToInclude', []),
                    props.vehicles.map((v: any) => v.id),
                    props.isCivilJudiciaryProcess,
                  ).includes(v.id),
                )
                .map(
                  (vehicle: { id: number; firstName: any; lastName: any }) => (
                    <FormGroup key={uniqueId()} style={StyledCheckBox}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isCheckedVehicle(vehicle.id)}
                            name={
                              featureService.hasFeature(
                                FEATURES.MIGRATION_CLAIM_INFO,
                              ) &&
                              !isEmpty(
                                getVehicleFromSagisInfo(
                                  get(vehicle, 'partKey'),
                                  props.sagisOpposingParties,
                                ),
                              )
                                ? get(
                                    getVehicleFromSagisInfo(
                                      get(vehicle, 'partKey'),
                                      props.sagisOpposingParties,
                                    ),
                                    'lastName',
                                  ) +
                                  ' ' +
                                  get(
                                    getVehicleFromSagisInfo(
                                      get(vehicle, 'partKey'),
                                      props.sagisOpposingParties,
                                    ),
                                    'firstName',
                                  )
                                : `${vehicle.firstName} ${vehicle.lastName}`
                            }
                            color="primary"
                            value={vehicle.id}
                            onChange={handleCheckVehicle}
                          />
                        }
                        label={
                          featureService.hasFeature(
                            FEATURES.MIGRATION_CLAIM_INFO,
                          ) &&
                          !isEmpty(
                            getVehicleFromSagisInfo(
                              get(vehicle, 'partKey'),
                              props.sagisOpposingParties,
                            ),
                          )
                            ? get(
                                getVehicleFromSagisInfo(
                                  get(vehicle, 'partKey'),
                                  props.sagisOpposingParties,
                                ),
                                'lastName',
                              ) +
                              ' ' +
                              get(
                                getVehicleFromSagisInfo(
                                  get(vehicle, 'partKey'),
                                  props.sagisOpposingParties,
                                ),
                                'firstName',
                              )
                            : `${vehicle.firstName} ${vehicle.lastName}`
                        }
                      />
                    </FormGroup>
                  ),
                )}
            </div>
          </Grid>
        </Grid>
      )}
    </SahamDrawer>
  );
};

export default injectIntl(AddJomDrawer);
